// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function PaperAirplane(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "PaperAirplane" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M2.00952 21L22 12L2.00952 3L2 10L16.2857 12L2 14L2.00952 21Z", fill: "currentColor" }))));
});
//# sourceMappingURL=PaperAirplane.js.map